import React from 'react'
import { connect } from 'react-redux'
import { change } from 'redux-form'
import cn from 'classnames'
import './equipment-field.scss'
import Formatter from './Formatter'
import EquipmentWidgetModal from './EquipmentWidgetModal'

const EquipmentField = ({ input, meta, changeFormValue }) => {
  const { value } = input
  return (
    <div className="ej-equipment-field">
      <Formatter input={input} changeFormValue={changeFormValue} />
      <div className={cn({ 'd-none': value })}>
        <EquipmentWidgetModal input={input} meta={meta} />
      </div>
    </div>
  )
}

const enchance = connect(
  null,
  (dispatch, { meta: { form } }) => ({
    changeFormValue: (field, value) => dispatch(change(form, field, value)),
  }),
)

export default enchance(EquipmentField)
